import { render, staticRenderFns } from "./Handover.vue?vue&type=template&id=404d6900"
import script from "./Handover.vue?vue&type=script&lang=js"
export * from "./Handover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports